import React from 'react'

const Check = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
)

const TIERS = [
  {
    name: 'Praticien\u00b7ne',
    featured: true,
    desc: 'Pour le vétérinaire en exercice.',
    amount: '12\u20ac',
    per: '/ mois',
    sub: 'Essai gratuit \u00b7 sans engagement.',
    cta: { label: "Commencer l'essai", href: 'https://app.fetchy.vet', accent: true, modal: null },
    feats: [
      'Rations illimitées, chien & chat',
      'Cibles FEDIAF, AAFCO & littérature',
      'Prescription PDF personnalisée',
      'Historique du patient dans le temps',
      '30 jours offerts',
    ],
  },
  {
    name: '\u00c9tudiant\u00b7e',
    featured: false,
    desc: 'Accès complet pendant tes études.',
    amount: 'Gratuit',
    per: '',
    sub: 'Sur justificatif de scolarité.',
    cta: { label: "Demander un accès", href: '#', accent: false, modal: 'student' },
    feats: [
      'Accès complet à Fetchy',
      'Idéal pour se former',
      'Partenaires Arginine inclus',
      'Un justificatif suffit',
    ],
  },
  {
    name: 'Clinique / \u00c9cole',
    featured: false,
    desc: 'Structures multi-vétérinaires & écoles.',
    amount: 'Sur devis',
    per: '',
    sub: 'Facturation groupée.',
    cta: { label: 'Demander un devis', href: '#', accent: false, modal: 'clinic' },
    feats: [
      'Comptes multiples & rôles',
      'Facturation B2B centralisée',
      'Onboarding accompagné',
      'Écoles & chaînes vétérinaires',
      'Conditions partenaires CPD',
    ],
  },
]

const Pricing = ({ onOpenModal }) => (
  <section className="vt-section" id="pricing">
    <div className="vt-shell">
      <div className="sec-head">
        <span className="eyebrow">Tarifs</span>
        <h2>Un plan pour chaque structure.</h2>
        <p>Commencez gratuitement. Passez à l'échelle quand votre équipe est prête.</p>
      </div>

      <div className="ptiers">
        {TIERS.map((t) => (
          <div className={`ptier${t.featured ? ' ptier--featured' : ''}`} key={t.name}>
            {t.featured && <span className="ptier__flag">Recommandé</span>}
            <div className="ptier__name">{t.name}</div>
            <div className="ptier__for">{t.desc}</div>
            <div className="ptier__price">
              <span className="ptier__amt">{t.amount}</span>
              {t.per && <span className="ptier__per">{t.per}</span>}
            </div>
            <div className="ptier__sub">{t.sub}</div>
            <div className="ptier__cta">
              {t.cta.modal ? (
                <button
                  className={`vt-btn vt-btn-lg w100 ${t.cta.accent ? 'vt-btn-call' : 'vt-btn-outline'}`}
                  onClick={() => onOpenModal && onOpenModal(t.cta.modal)}
                >
                  {t.cta.label}
                </button>
              ) : (
                <a
                  className={`vt-btn vt-btn-lg w100 ${t.cta.accent ? 'vt-btn-call' : 'vt-btn-outline'}`}
                  href={t.cta.href}
                >
                  {t.cta.label}
                </a>
              )}
            </div>
            <div className="ptier__feats">
              {t.feats.map((f, i) => (
                <div className="ptier__feat" key={i}><Check />{f}</div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Arginine partner */}
      <div className="arg" style={{ marginTop: 32 }}>
        <div className="badge-ic"><i data-lucide="handshake"></i></div>
        <div>
          <h3>Partenaire Arginine</h3>
          <p>Fetchy est offert aux formations Arginine. Tu suis une formation partenaire ? Ton accès est déjà prévu — écris-nous.</p>
        </div>
        <a className="vt-btn vt-btn-dark" href="https://arginine-formation.com/" target="_blank" rel="noopener noreferrer">Découvrir Arginine</a>
      </div>
    </div>
  </section>
)

export default Pricing
